<div class="back"></div>
<div class="div-center">
  <div class="row mb-2 items-center">
    <div class="col-sm-6 col-md-3">
      <img src="/images/cone.png">
    </div>
    <div class="col-sm-5 col-md-9">
      <div>
        <h1> <span class="text-danger"><strong>{{'EXPRESSOES.EITA' | transloco }}</strong>
          </span><strong>{{'LOGIN.NAO_AUTORIZADO' | transloco }}</strong>
        </h1>
        <p class="lead">
          {{'LOGIN.BLOQUEADO' | transloco}}
        </p>
        <dx-button class="aias-button-principal" [text]="'LOGIN.FACA_LOGIN' | transloco"
          [routerLink]="['/login']"></dx-button>
      </div>
    </div>
  </div>
</div>